/**
 * La démarche est-elle déjà partie au ministère malgré l'erreur reçue ?
 *
 * Deux réponses du backend disent la même chose : le véhicule EST déclaré au
 * SIV, seul le récépissé manque.
 * - 500 `receiptPending` : MiSIV a accepté l'envoi, le récépissé n'a pas pu être
 *   récupéré ou uploadé.
 * - 409 `alreadySubmitted` : une soumission acceptée existe déjà pour cette DA,
 *   le backend refuse d'en créer une seconde.
 *
 * Dans les deux cas la seule action utile est « Régénérer DA ». Renvoyer la
 * démarche déclarerait le véhicule une nouvelle fois — DP-853-FV s'est retrouvée
 * avec cinq déclarations d'achat au ministère le 20/08/2026.
 */
export interface MinistrySubmissionErrorPayload {
  receiptPending?: boolean;
  alreadySubmitted?: boolean;
  responseId?: number;
  message?: string;
}

export const isSubmissionAlreadyAtMinistry = (error: {
  response?: { data?: MinistrySubmissionErrorPayload };
}): boolean => error?.response?.data?.receiptPending === true || error?.response?.data?.alreadySubmitted === true;
